// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2328":"5a4e36c3","4228":"d69007d9","5538":"e27ce511"}[chunkId] + ".chunk.css";
};